import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import './plugins/element.js'
import axios from 'axios'
import TreeTable from 'vue-table-with-tree-grid'
// 导入Nprogress包
import Nprogress from 'nprogress'

// 导入父文本编辑器
import VueQuillEditor from 'vue-quill-editor'

Vue.config.productionTip = false

// request 拦截器中,展示进度条

// 设置请求拦截器，预处理请求，添加上token
axios.interceptors.request.use(confit => {
  Nprogress.start()
  confit.headers.Authorization = window.sessionStorage.getItem('token')

  return confit
})

axios.interceptors.response.use(config => {
  Nprogress.done()
  return config
})
// 设置请求根路径
axios.defaults.baseURL = 'http://121.40.123.168:8889/api/private/v1/'

Vue.prototype.$http = axios

Vue.component('tree-table', TreeTable)
// 将富文本编辑器组测为全局可用
Vue.use(VueQuillEditor /* { default global options } */)

Vue.filter('dataFormat', function (originVal) {
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
